import React, { useEffect, useState } from 'react';
import { Button, Form, Row, Col, Modal } from 'react-bootstrap';
import { useMutation, useQueryClient } from 'react-query';
import { Formik } from 'formik';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import { PHANBIENDOCLAP_API } from '../../../../utils/apiUrl';
import { Put } from '../../../../utils/httpProvider';
import DocumentInput from '../../../../components/document-input/DocumentInput';

const schema = yup.object().shape({
});

const PhanBienDocLapEdit = ({ hoSoId, dataEdit, setViewMode, refreshList }) => {
    const queryClient = useQueryClient();
    const [initialValues, setInitialValues] = useState(null);

    useEffect(() => {
        if (dataEdit) {
            setInitialValues({
                isBanGiaiTrinh: dataEdit.isBanGiaiTrinh ? 'true' : 'false',
                fileDinhKem: dataEdit.fileDinhKem || ''
            });
        }
    }, [dataEdit]);

    const editFunc = useMutation((value) => Put(`${PHANBIENDOCLAP_API.UPDATE_ITEM}/${dataEdit.id}`, null, value, false));

    const handleUpdate = (values, { setSubmitting }) => {
        const requestData = {
            HoSoNghienCuuSinhId: hoSoId,
            IsBanGiaiTrinh: values.isBanGiaiTrinh === 'true',
            FileDinhKem: values.isBanGiaiTrinh === 'true' ? (values.fileDinhKem || '') : ''
        };

        editFunc.mutate(requestData, {
            onSuccess: (res) => {
                setSubmitting(false);
                if (res && (res.status === 200 || res.status === 201 || res.status === 204 || res.id)) {
                    toast.success('Cập nhật thành công');
                    queryClient.invalidateQueries(['duyetPhanBienDocLapData', hoSoId]);
                    if (refreshList) {
                        refreshList();
                    }
                    setViewMode('list');
                } else {
                    toast.error(res?.message || 'Có lỗi xảy ra');
                }
            },
            onError: (err) => {
                setSubmitting(false);
                toast.error(err?.message || 'Có lỗi xảy ra trong quá trình xử lý');
            }
        });
    };

    if (!initialValues) return null;

    return (
        <Modal show={true} onHide={() => setViewMode('list')} size="lg" backdrop="static">
            <Modal.Header closeButton className="bg-primary text-white">
                <Modal.Title>Cập nhật Phản biện độc lập</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={handleUpdate}
                    initialValues={initialValues}
                    enableReinitialize
                >
                    {({ handleSubmit, handleChange, handleBlur, values, errors, touched, isSubmitting, setFieldValue }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Row>
                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold d-block">Biên bản giải trình</Form.Label>
                                        <Form.Check
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isBanGiaiTrinh"
                                            id="isBanGiaiTrinh-true"
                                            value="true"
                                            checked={values.isBanGiaiTrinh === 'true'}
                                            onChange={handleChange}
                                        />
                                        <Form.Check
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isBanGiaiTrinh"
                                            id="isBanGiaiTrinh-false"
                                            value="false"
                                            checked={values.isBanGiaiTrinh === 'false'}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            {values.isBanGiaiTrinh === 'true' && (
                                <Row>
                                    <Col md={12}>
                                        <Form.Group>
                                            <DocumentInput
                                                labelTitle="File đính kèm"
                                                value={values.fileDinhKem}
                                                onChangeProp={(url) => setFieldValue('fileDinhKem', url)}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            )}

                            <div className="text-right mt-3">
                                <Button variant="secondary" className="mr-2" onClick={() => setViewMode('list')} disabled={isSubmitting}>
                                    Đóng
                                </Button>
                                <Button variant="primary" type="submit" disabled={isSubmitting}>
                                    {isSubmitting ? 'Đang lưu...' : 'Cập nhật'}
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
};

export default PhanBienDocLapEdit;
